import { useCallback } from 'react';
import { useTimeRange } from '../contexts/TimeRangeContext';

/**
 * Custom hook that wraps fetch to automatically append time_window query parameter
 *
 * @returns {Object} Object containing fetchWithTimeWindow function and selectedRange value
 */
export const useFetchWithTimeWindow = () => {
  const { selectedRange } = useTimeRange();

  const fetchWithTimeWindow = useCallback(async (url, options = {}) => {
    const urlObj = new URL(url);
    urlObj.searchParams.append('time_window', selectedRange);
    return fetch(urlObj, options);
  }, [selectedRange]);

  return { fetchWithTimeWindow, selectedRange };
};
